export default __webpack_public_path__ + "static/soon-en-a0b2400e2352e991e82224cb07820427.svg";